import { render } from "./LandingFederations.vue?vue&type=template&id=01c0f7d8&scoped=true&ts=true"
import script from "./LandingFederations.vue?vue&type=script&lang=ts"
export * from "./LandingFederations.vue?vue&type=script&lang=ts"

import "./LandingFederations.vue?vue&type=style&index=0&id=01c0f7d8&lang=scss&scoped=true"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c0f7d8"]])

export default __exports__